import React from 'react';
import {Drawer} from "../../fusion-ui";
import {useTheme} from "../../ProjectThemeProvider";

/**
 * Create a theme-based drawer component.
 *
 * @example
 * const [openDrawer, setOpenDrawer] = useState(false);
 * <ThemedDrawer
 *       title={'Drawer title'}
 *       subtitle={'Drawer subtitle'}
 *       closeOnEscape={true}
 *       closeOnClickAway={false}
 *       detached={true}
 *       open={openDrawer}
 *       onClose={() => {
 *           setOpenDrawer(false);
 *       }}>
 *       children
 * </ThemedDrawer>
 */
const ThemedDrawer = React.memo(({
                                     children,
                                     open = false,
                                     title,
                                     subtitle,
                                     titleContent,
                                     closeClassName = '',
                                     headerClassName = '',
                                     titleClassName = '',
                                     subtitleClassName = '',
                                     titleWrapperClassName = '',
                                     onOpen,
                                     onClose,
                                     titleSize,
                                     showClose = true,
                                     blurredBg = false,
                                     closeOnEscape = true,
                                     closeOnClickAway = true,
                                     closeOnClose = true,
                                     detached = false,
                                     bg = 'white',
                                     width = '50%',
                                     widthSm = '85%',
                                     height = '95%',
                                     titleAt = 'center',
                                     subtitleAt = 'center',
                                     placement = 'right',
                                     headerBg,
                                     className = '',
                                     padded = true,
                                     contentClassName = '',
                                     style = {},
                                     contentStyle = {},
                                     titleStyle = {},
                                     subtitleStyle = {},
                                     headerStyle = {},
                                     closeStyle = {},
                                     loadingStatus = {},
                                     headerContent,
                                     ...rest
                                 }) => {
    const TAG = "ThemedDrawer";
    const theme = useTheme();

    return (<>
            <Drawer
                className={`${className}`}
                headerClassName={`pb-2 ${headerClassName}`}
                closeClassName={`${closeClassName}`}
                titleWrapperClassName={`${titleWrapperClassName}`}
                title={title}
                subtitle={subtitle}
                subtitleAt={subtitleAt}
                titleAt={titleAt}
                titleClassName={`fw-bold fs-normal ${titleClassName}`}
                subtitleClassName={`${subtitleClassName}`}
                contentClassName={`d-flex jc-center al-start bg-dangerx w-100 pt-1 ${padded ? 'px-3 pb-3' : 'px-0 pb-1'} ${contentClassName}`}
                style={style}
                subtitleStyle={{color: theme.text80, ...subtitleStyle}}
                titleStyle={{color: theme.text, ...titleStyle}}
                contentStyle={{color: theme.text, ...contentStyle}}
                headerStyle={{backgroundColor: theme.text10, ...headerStyle}}
                closeColor={theme.text}
                bg={theme.bg}
                backdropColor={theme.text10}
                closeStyle={{...closeStyle}}
                detached={detached}
                headerContent={headerContent}
                closeOnEscape={closeOnEscape}
                closeOnClickAway={closeOnClickAway}
                closeOnClose={closeOnClose}
                placement={placement}
                width={width}
                widthSm={widthSm}
                open={open}
                onClose={onClose}
                {...rest}
            >
                {children}
            </Drawer>
        </>
    )

    function fun() {

    }
});
export default ThemedDrawer;
